export class BooleanFilters {
    'is';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "is",
            "baseName": "is",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BooleanFilters.attributeTypeMap;
    }
    constructor() {
    }
}
